import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterModel } from "ag-grid-community";
import { TmmSelection } from "./tmmTypes";

export const samTmmSliceName = "samTmm";

export interface SamTmmState {
  selection: TmmSelection;
  columnFilter: FilterModel;
}

const initialState: SamTmmState = {
  selection: {
    tmmEntries: [],
  },
  columnFilter: {},
};

const samSlice = createSlice({
  name: samTmmSliceName,
  initialState,
  reducers: {
    setTmmSelection(state: SamTmmState, action: PayloadAction<TmmSelection>) {
      state.selection = action.payload;
    },
    setTmmColumnFilter(state: SamTmmState, action: PayloadAction<FilterModel>) {
      state.columnFilter = action.payload;
    },
  },
});

export interface SamTmmRootState {
  [samTmmSliceName]: SamTmmState;
}

export const selectSamTmm = (state: SamTmmRootState) => state[samTmmSliceName];
export const selectSamTmmSelection = (state: SamTmmRootState) => {
  return selectSamTmm(state).selection;
};
export const selectSamTmmColumnFilter = (state: SamTmmRootState) => {
  return selectSamTmm(state).columnFilter;
};

export const {
  setTmmSelection,
  setTmmColumnFilter,
} = samSlice.actions;
export const samTmmReducer = samSlice.reducer;
